import React from 'react'
import { useApplicationContext } from '../provider'

const ExperimentHoc = ({ children }: any) => {
  const { experiments } = useApplicationContext()

  if (experiments.integrationBuilder === true) {
    return children
  }
  return <></>
}

export default ExperimentHoc
